import apiClient from './client';
import type {
  NotificationsPage,
  UnreadCountResponse,
} from '../types/notifications.types';

// === СПИСОК ===

export interface GetNotificationsParams {
  /** Курсор следующей страницы (nextCursor из предыдущего ответа) */
  cursor?: string;
  /** Только невыполненные — задача ещё открыта */
  unresolvedOnly?: boolean;
  limit?: number;
}

export const getNotifications = async (
  params: GetNotificationsParams = {}
): Promise<NotificationsPage> => {
  const response = await apiClient.get<NotificationsPage>('/notifications', {
    params: {
      ...(params.cursor ? { cursor: params.cursor } : {}),
      ...(params.unresolvedOnly ? { unresolvedOnly: true } : {}),
      ...(params.limit ? { limit: params.limit } : {}),
    },
  });
  return response.data;
};

// === СЧЁТЧИК НЕПРОЧИТАННЫХ ===

export const getUnreadCount = async (): Promise<UnreadCountResponse> => {
  const response = await apiClient.get<UnreadCountResponse>(
    '/notifications/unread-count'
  );
  return response.data;
};

// === ОТМЕТКА ПРОЧИТАННЫМ ===

export const markNotificationRead = async (
  id: string
): Promise<{ success: boolean }> => {
  const response = await apiClient.post<{ success: boolean }>(
    `/notifications/${id}/read`
  );
  return response.data;
};

export const markAllNotificationsRead = async (): Promise<{
  success: boolean;
  updated: number;
}> => {
  const response = await apiClient.post<{ success: boolean; updated: number }>(
    '/notifications/read-all'
  );
  return response.data;
};

export const notificationsApi = {
  getNotifications,
  getUnreadCount,
  markNotificationRead,
  markAllNotificationsRead,
};

export default notificationsApi;
